import { Box, Popper, PopperProps, Stack, Button } from '@mui/material';
import { FC } from 'react';
import useLocales from '~/hooks/useLocales';
import { styles } from './styles';

type DashboardPopperProps = {
  handleClear: () => void;
  handleApply: () => void;
};

type Props = DashboardPopperProps & PopperProps;

const DashboardPopper: FC<Props> = ({ handleApply, handleClear, ...params }) => {
  const { t } = useLocales();

  return (
    <Popper {...params}>
      <Box {...params} sx={styles.list} />
      <Box sx={styles.controls}>
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleClear} variant="text" sx={styles.clearButton}>
            {t('dashboard.filters.clear')}
          </Button>
          <Button onClick={handleApply} variant="contained">
            {t('dashboard.filters.apply')}
          </Button>
        </Stack>
      </Box>
    </Popper>
  );
};

export default DashboardPopper;
